import React, { useState, useEffect, useMemo } from 'react';
import DataTable from 'react-data-table-component';
import Layout from '../../views/layout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faRedo, faEdit } from '@fortawesome/free-solid-svg-icons';
import Services from '../../services/global.service';
import DeleteModal from '../../components/modals/delete';
import DateTimePicker from 'react-datetime-picker';
import 'react-datetime-picker/dist/DateTimePicker.css';
import 'react-calendar/dist/Calendar.css';
import 'react-clock/dist/Clock.css';
import '../../styles/datetime-picker.css';
import CustomDateTimePicker from '../../components/DateTimePicker';



function Notifs() {
  const [notifs, setNotif] = useState([]);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [action, setAction] = useState('');
  const [idToDeleted, setIdToDelete] = useState('');
  const [showNotifForm, setShowNotifForm] = useState(false);
  const [notifTitle, setNotifTitle] = useState('');
  const [notifText, setNotifText] = useState('');
  const [notifDateTime, setNotifDateTime] = useState('');
  const [filterText, setFilterText] = useState('');
  const [filteredItems, setFilteredItems] = useState([]);

  const customStyles = {
    table: {
      style: {
        backgroundColor: '#FCFCFC',
        fontSize: "16px",
      },
    },
    headCells: {
      style: {
        backgroundColor: '#F4F3F3',
        fontSize: "16px",
        fontFamily: 'Lato-Bold',
        fontWeight: '600',
      }
    },
    rows: {
      style: {
        cursor: 'pointer',
        backgroundColor: "#fff",
        fontSize: "16px",
        fontFamily: 'Lato-Light',
        minHeight: '64px'
      },
    },
  };

  const paginationComponentOptions = {
    rowsPerPageText: 'Lignes par page',
    rangeSeparatorText: 'de',
    selectAllRowsItem: true,
    selectAllRowsItemText: 'Tous',
  };

  function handleDelete(id) {
    setIdToDelete(id);
    setIsOpenDelete(true);
  }

  const handleSubmitNotif = (e) => {
    e.preventDefault();
    const notificationData = {
      title: notifTitle,
      message: notifText,
      sendDate: notifDateTime,
      status: 'enable'
    };

    if (action === 'edit') {
      Services.put(notificationData, idToDeleted, 'pushNotification')
        .then(() => {
          getNotifs();
          resetForm();
        })
        .catch(error => console.error('Error updating notification:', error));
    } else {
      Services.create(notificationData, 'pushNotification/')
        .then(() => {
          getNotifs();
          resetForm();
        })
        .catch(error => console.error('Error creating notification:', error));
    }
  };

  const resetForm = () => {
    setNotifTitle('');
    setNotifText('');
    setNotifDateTime('');
    setShowNotifForm(false);
  };

  const memoizedColumns = useMemo(() => [
    {
      name: 'ID notification',
      selector: (row, index) => index + 1,
      sortable: true,
      width: '100px'
    },
    {
      name: "Titre de la notification",
      selector: row => row.title,
      sortable: true,
      sortFunction: (a, b) => a.title.localeCompare(b.title, 'fr')
    },
    {
      name: 'Texte de la notification',
      selector: row => row.message,
      sortable: true,
      sortFunction: (a, b) => a.message.localeCompare(b.message, 'fr')
    },
    {
      name: 'Date d\'envoi',
      selector: row => row.sendDate,
      sortable: true,
      cell: row => {
        const date = new Date(row.sendDate);
        return date.toLocaleDateString("fr-FR", {
          year: "numeric",
          month: "numeric",
          day: "numeric",
        }) + " " + date.toLocaleTimeString("fr-FR");
      },
      sortFunction: (a, b) => new Date(a.sendDate) - new Date(b.sendDate)
    },
    {
      name: "Statut de la notification",
      selector: row => row.status,
      sortable: true,
      cell: row => (
        <span className={row.status === "enable" ? "text-success" : "text-danger"}>
          {row.status === "enable" ? "Activée" : "Désactivée"}
        </span>
      ),
      sortFunction: (a, b) => a.status.localeCompare(b.status)
    },
    {
      name: "",
      cell: row => (
        <div className="btn-group" role="group" aria-label="Basic example">
          <button
            type="button"
            className='btn-secondary-ko'
            style={{ margin: '5px' }}
            onClick={() => {
              handleDelete(row._id);
              setIdToDelete(row._id);
              setAction('disable');
            }}
          >
            <FontAwesomeIcon icon={faTrash} />
          </button>
          <button
            type="button"
            className='btn-secondary-ko'
            style={{ margin: '5px' }}
            onClick={() => {
              setNotifTitle(row.title);
              setNotifText(row.message);
              setNotifDateTime(row.sendDate);
              setShowNotifForm(true);
              setIdToDelete(row._id);
              setAction('edit');
            }}
          >
            <FontAwesomeIcon icon={faEdit} />
          </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ], []);

  const subHeaderComponent = useMemo(() => {
    return (
      <div className='col-md-12'>
        <input
          className='form-control'
          id="search"
          type="text"
          placeholder="Recherche"
          value={filterText}
          onChange={e => setFilterText(e.target.value)}
        />
      </div>
    );
  }, [filterText]);

  function getNotifs() {
    Services.getAllAdmin('pushNotification/', localStorage.getItem('token'))
      .then((response) => {
        setNotif(response?.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  const hideModal = () => {
    setIsOpenDelete(!isOpenDelete);
  };

  const DeleteAnnonce = () => {
    Services.deleteByid(idToDeleted, 'pushNotification')
      .then(() => {
        getNotifs();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    getNotifs();
  }, [idToDeleted, isOpenDelete]);

  useEffect(() => {
    if (notifs) {
      let filtered = [...notifs];
      
      if (filterText) {
        const searchTerm = filterText.toLowerCase();
        filtered = filtered.filter(item => 
          (item.title?.toLowerCase().includes(searchTerm) || '') ||
          (item.message?.toLowerCase().includes(searchTerm) || '') ||
          (item.status?.toLowerCase().includes(searchTerm) || '')
        );
      }

      setFilteredItems(filtered);
    }
  }, [filterText, notifs]);

  return (
    <Layout>
      {isOpenDelete && (
        <DeleteModal
          isOpenDelete={isOpenDelete}
          setIsOpenDelete={setIsOpenDelete}
          hideModal={hideModal}
          Function={DeleteAnnonce}
          title="Souhaitez-vous supprimer/archiver cette notification ?"
        />
      )}
      <div className="col bg-fond container-k">
        <div className="m-vh-100 p-40">
          <div className="container">
            <div className="d-flex justify-content-between">
              <h1 className="d-title">
                Liste notifications <span className="border-title"></span>
              </h1>
              <button
                className='btn-primary-ko'
                onClick={() => {
                  resetForm();
                  setAction('create');
                  setShowNotifForm(true);
                }}
              >
                Planifier une notification
              </button>
            </div>

            {showNotifForm && (
              <div className="modal" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
                <div className="modal-dialog modal-dialog-centered">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h3 className="modal-title">Planifier une notification</h3>
                      <button type="button" className="btn-close" onClick={resetForm}></button>
                    </div>
                    <div className="modal-body">
                      <form onSubmit={handleSubmitNotif}>
                        <div className="form-group mb-3">
                          <label>Titre (max 30 caractères)</label>
                          <input
                            type="text"
                            className="form-control"
                            maxLength={30}
                            value={notifTitle}
                            onChange={(e) => setNotifTitle(e.target.value)}
                            required
                          />
                        </div>
                        <div className="form-group mb-3">
                          <label>Texte (max 50 caractères)</label>
                          <textarea
                            className="form-control"
                            maxLength={50}
                            value={notifText}
                            onChange={(e) => setNotifText(e.target.value)}
                            required
                          />
                        </div>
                        <div className="form-group mb-3">
                          <label>Date et heure d'envoi :</label>
                          <CustomDateTimePicker
                            value={notifDateTime ? new Date(notifDateTime) : null}
                            onChange={(date) => {
                              if (date) {
                                setNotifDateTime(date);
                              } else {
                                setNotifDateTime('');
                              }
                            }}
                            label="Sélectionnez la date et l'heure"
                            minDate={new Date()}
                            required={true}
                          />
                        </div>
                        <div className="modal-footer">
                          <button type="submit" className="btn-primary-ko">Enregistrer</button>
                          <button
                            type="button"
                            className="btn-secondary-ko"
                            onClick={resetForm}
                          >
                            Annuler
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="space-72"></div>
          </div>
          <div className="koper">
            {notifs && (
              <DataTable
                columns={memoizedColumns}
                data={filteredItems}
                className="datatable-all mt-24"
                pagination
                paginationComponentOptions={paginationComponentOptions}
                customStyles={customStyles}
                subHeader
                subHeaderComponent={subHeaderComponent}
                noDataComponent={<div className="p-3">Aucune notification trouvée</div>}
                defaultSortFieldId={3}
                defaultSortAsc={true}
                progressPending={!notifs}
                progressComponent={<div className="p-3">Chargement...</div>}
              />
            )}
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default Notifs;
